import { normalizeChannelInfluencers } from './helpFunctions'
import { getPaginationModule } from './pagination'

import { RepositoryFactory } from '@/legacy/repositories/RepositoryFactory'
const StoreRepository = RepositoryFactory.get('store')

const channelInfluencers = getPaginationModule(
  StoreRepository.getUserStats,
  normalizeChannelInfluencers,
  {
    sortBy: 'clicks',
    sortOrder: 'desc',
  },
)

export default channelInfluencers
